import { AxiosInstance } from 'axios';

import { CartProduct } from '../../types/CartProduct';
import { cartProductEndpoints } from '../../utils/constants/endpoints';
import { axios } from '../axiosInstance';

import { AddProductInput, UpdateCartProductInput } from './CartProductApi.schema';

class CartProductApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  addToCart = async (input: AddProductInput): Promise<AddProductInput> =>
    this.#requestInstance.post(cartProductEndpoints.cartProduct, input);

  getCartProducts = async (id: number): Promise<CartProduct[]> =>
    this.#requestInstance.get(cartProductEndpoints.cartProductId(id));

  updateCartProducts = async (input: UpdateCartProductInput): Promise<void> =>
    this.#requestInstance.patch(cartProductEndpoints.cartProductId(input.id), input.body);

  deleteCartProducts = async (id: number): Promise<void> =>
    this.#requestInstance.delete(cartProductEndpoints.cartProductId(id));

  // TODO: delete before deployment
  restoreCartProduct = async (id: number): Promise<void> =>
    this.#requestInstance.get(cartProductEndpoints.restoreCartProduct(id));
}

export const cartProductApi = new CartProductApi(axios);
